import { Fragment } from 'react';
import { View } from 'react-native';
import Collapsible from 'react-native-collapsible';
import { Divider, Text } from '@ui-kitten/components';

import Button from '../../Components/Button';
import Switch from '../../Components/Switch';
import constants from '../../Config/constants';
import { checkout } from '../../RTK/defaultValues';
import ThemeStyle from '../../Theme/styles';
import { SECTION_TITLE_LIGHT } from '../../Theme/typographyProps';

import useCheckoutHandler from './controller/useCheckoutHandler';
import styles from './styles';
import ThirdPartyAndVehicleInputs from './ThirdPartyAndVehicleInputs';

const fields = [
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'contactNumber', label: 'Contact Number', type: 'phone' },
];

function ThirdPartyPickup({ disabled }) {
  const { isPickup, formThirdPartyPickDetails, onUpdateCheckoutDetails } =
    useCheckoutHandler();
  const isChecked = formThirdPartyPickDetails?.isChecked || false;

  const _onChange = (key) => (fieldValue) => {
    onUpdateCheckoutDetails(checkout.keys.THIRD_PARTY_PICKUP, {
      ...formThirdPartyPickDetails,
      [key]: fieldValue,
    });
  };

  if (!isPickup) return null;

  return (
    <Fragment>
      <View style={ThemeStyle.pageVerticalSpacingMedium}>
        <View style={styles.webBox}>
          <Button
            onPress={() => _onChange('isChecked')(!isChecked)}
            style={[
              ThemeStyle.flex1,
              ThemeStyle.flexDirectionRowCenterSpaceBetween,
            ]}
            plain
          >
            <Text
              {...(constants.isWeb ? { category: 's2' } : SECTION_TITLE_LIGHT)}
            >
              This order is for someone else
            </Text>

            <Switch
              value={isChecked}
              onChange={_onChange('isChecked')}
              disabled={disabled}
            />
          </Button>

          <Collapsible collapsed={!isChecked}>
            <View style={ThemeStyle.spacingTopSmall}>
              <ThirdPartyAndVehicleInputs
                disabled={disabled}
                fields={fields}
                value={formThirdPartyPickDetails}
                onChange={_onChange}
              />
            </View>
          </Collapsible>
        </View>
      </View>
      {!constants.isWeb && <Divider style={ThemeStyle.divider} />}
    </Fragment>
  );
}

export default ThirdPartyPickup;
